export default "__VITE_ASSET__D$VGzzZf__"